// Single source of truth for the pass/fail colored-text treatment used across the report
// viewer (test-tile/result.tsx's non-SDA Result heading, and the SDA Result cell) — keeps the
// two branches' colors from drifting apart if the palette is ever tweaked.
export const PASS_COLOR = '#16DB65';
export const FAIL_COLOR = '#ff0000';
